import { useEffect, useRef, useState } from "react";
import React from "react";
import { Row, Col, Container, Button } from "reactstrap";
import { ExpansiblePanelPI } from "./ExpansiblePanel";

interface Props {
    roles: Array<string>,
    usuario: string,
    nombres: string;
    apellidos: string;
    autorizado: boolean;
}

export default function WebPresupuesto(props: Props) {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const RolDirectivo = "DIRECTIVO_UNIDAD";
    const RolAnalista = "";

    const autoAuth = "true";
    const IdUrl = "b7af8caf-83d8-4644-85ae-317c545223c1";

    let EnlacePowerBIDirectivo = "https://app.powerbi.com/reportEmbed?reportId=4374af7a-0668-4017-948d-e63bc9d930d5&autoAuth=" + autoAuth + "&ctid=" + IdUrl;
    let EnlacePowerBI = "https://app.powerbi.com/reportEmbed?reportId=4374af7a-0668-4017-948d-e63bc9d930d5&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1";

    let [link, setLink] = useState('');
    let [linkIf, setLinkIf] = useState('');

    const openLinkInNewTab = (link: string) => {
        const url = link; // Reemplaza esto con tu URL deseada
        window.open(url, '_blank');
    };

    useEffect(() => {
        if (props.roles.includes(RolAnalista)) {
            setLinkIf(EnlacePowerBI);
            if (props.roles.includes(RolDirectivo)) {
                setLinkIf(EnlacePowerBI);
            }
        }else if(props.roles.includes(RolDirectivo)) {
            setLinkIf(EnlacePowerBI);
        }
    }, [props.autorizado])

    return (
        <>
            {props.autorizado && (
                props.autorizado ?
                    <>
                        <div className="mb-3">
                            <Row>
                                <Col xs={10} sm={10} md={10} lg={10}>
                                    <h5 className="mb-2">Dashboard Horas Extras</h5>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2}></Col>
                            </Row>
                        </div>
                        <ExpansiblePanelPI title="Antes de iniciar sesión" nombres={props.nombres} apellidos={props.apellidos} usuario={props.usuario} />
                        <div style={{ display: "grid", gap: "16px", padding: "8px" }}>
                            <div style={{ gridColumn: "1 / -1" }}>
                                <iframe
                                    ref={iframeRef}
                                    title="ReporteSolicitudesHorasExtras"
                                    style={{ width: "100%", height: "700px", border: "none" }}
                                    src={linkIf}
                                ></iframe>
                            </div>
                        </div>
                    </>
                    :
                    <Container style={{ maxWidth: "600px", marginTop: "8rem" }}>
                        <div style={{ textAlign: "center", marginTop: "2rem" }}>
                            <h4>No tienes permisos</h4>
                            <p>No tienes permisos para acceder a esta página.</p>
                            <br />
                            <Button variant="contained" aria-label="delete" color="primary" onClick={() => { }}>
                                VOLVER
                            </Button>
                        </div>
                    </Container>
            )
            }
            {!props.autorizado && (
                <Container style={{ maxWidth: "600px", marginTop: "8rem" }}>
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <h4>No tienes permisos</h4>
                        <p>No tienes permisos para acceder a esta página.</p>
                        <br />
                        <Button variant="contained" aria-label="delete" color="primary" onClick={() => { }}>
                            VOLVER
                        </Button>
                    </div>
                </Container>
            )
            }
        </>
    );
}
